export default __webpack_public_path__ + "static/media/dashboard-3.b11daff9.png";